const DEFAULT_CURRENCY = "BRL";

export const formatMoneyFromCents = (
  cents: number,
  locale: string,
  currency: string = DEFAULT_CURRENCY
): string =>
  new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  }).format(cents / 100);

const escapeRegExp = (value: string): string =>
  value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const getLocaleMoneySeparators = (
  locale: string
): { decimal: string; group: string } => {
  const parts = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).formatToParts(11111.11);

  return {
    decimal: parts.find((part) => part.type === "decimal")?.value ?? ".",
    group: parts.find((part) => part.type === "group")?.value ?? ",",
  };
};

export const formatCentsToMoneyInput = (cents: number, locale?: string): string => {
  if (!locale) {
    return (cents / 100).toFixed(2);
  }

  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  }).format(cents / 100);
};

export const parseMoneyInputToCents = (value: string, locale?: string): number => {
  const trimmed = value.trim();
  if (trimmed === "") {
    return 0;
  }

  let normalized: string;

  if (locale) {
    const { decimal, group } = getLocaleMoneySeparators(locale);
    normalized = trimmed
      .replace(new RegExp(escapeRegExp(group), "g"), "")
      .replace(decimal, ".")
      .replace(/[^\d.-]/g, "");
  } else {
    normalized = trimmed.includes(",")
      ? trimmed.replace(/\./g, "").replace(",", ".")
      : trimmed;
  }

  const parsed = Number.parseFloat(normalized);

  if (Number.isNaN(parsed)) {
    return 0;
  }

  return Math.round(parsed * 100);
};
